module.exports = __webpack_public_path__ + "img/img-chart-02.c122465d.png";